<section>
  <h3 class="title" *ngIf="email">
    <span class="green">{{email}},</span>
    seu email foi confirmado com sucesso, começe agora a usar sua conta !
  </h3>

  <button class="btn m-t-40" [routerLink]="['/login', email]">Ir para Login</button>

  <app-footer></app-footer>
</section>